import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import {Member, System} from "../api/Models";
import {PURGE} from "redux-persist/es/constants";

// Define a type for the slice state
export interface SystemState {
  system: System
  front: Member[]
}

// Define the initial state using that type
const initialState: SystemState = {
  system: {
    id: '',
    name: '',
    userId: '',
    parentId: null,
    createdAt: new Date(),
    members: [],
    updatedAt: null
  },
  front: []
}

export const systemSlice = createSlice({
  name: 'system',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    setSystem: (state, action: PayloadAction<System>) => {
      state.system = action.payload
    },
    setFront: (state, action: PayloadAction<Member|null>) => {
      const front = action.payload
      if (!front) {
        state.front = []
      } else {
        state.front = [front]
      }
    },
    setFronts: (state, action: PayloadAction<Member[]>) => {
      state.front = action.payload
    }
  }
})

export const { setSystem, setFront, setFronts } = systemSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectSystemName = (state: RootState) => state.system.system.name
export const selectSystem = (state: RootState) => state.system.system

export default systemSlice.reducer